import secureApi from '../../../utils/secureApi';
import { SHOP_ENDPOINTS } from '../endpoints';
import {
  Seller,
  SellerListResponse,
  AddSellerRequest,
  UpdateSellerRequest,
} from '../types/sellerTypes';

/**
 * Get list of sellers with pagination and filters
 */
export const getSellers = async (params: {
  pageNum?: number;
  status?: 'ACTIVE' | 'INACTIVE' | 'All';
}): Promise<SellerListResponse> => {
  try {
    const queryParams: any = {};
    if (params.pageNum) queryParams.pageNum = params.pageNum;
    if (params.status && params.status !== 'All') {
      queryParams.status = params.status;
    }

    const response = await secureApi.get<any>(SHOP_ENDPOINTS.SELLERS.LIST, {
      params: queryParams,
    });

    // Handle API response structure
    const apiData = (response as any)?.data || response;
    
    return {
      paginatedResults: (apiData.paginatedResults || apiData.sellers || []).map((seller: any) => ({
        ...seller,
        _id: seller._id || seller.id,
        id: seller.id || seller._id,
      })),
      totalCount: apiData.totalCount || 0,
      totalPages: apiData.totalPages || 1,
      page: params.pageNum || 1,
    };
  } catch (error) {
    throw error;
  }
};

/**
 * Get seller by ID
 */
export const getSellerById = async (id: string): Promise<Seller> => {
  try {
    const response = await secureApi.get<any>(SHOP_ENDPOINTS.SELLERS.GET_BY_ID(id));
    
    // Handle API response structure
    const apiData = (response as any)?.data || response;
    
    return {
      ...apiData,
      _id: apiData._id || apiData.id,
      id: apiData.id || apiData._id,
    };
  } catch (error) {
    throw error;
  }
};

/**
 * Add new seller
 */
export const addSeller = async (payload: AddSellerRequest): Promise<Seller> => {
  try {
    const response = await secureApi.post<any>(SHOP_ENDPOINTS.SELLERS.ADD, payload);
    
    // Handle API response structure
    const apiData = (response as any)?.data || response;
    
    return {
      ...apiData,
      _id: apiData._id || apiData.id,
      id: apiData.id || apiData._id,
    };
  } catch (error) {
    throw error;
  }
};

/**
 * Update seller
 */
export const updateSeller = async (id: string, payload: UpdateSellerRequest): Promise<Seller> => {
  try {
    const response = await secureApi.post<any>(SHOP_ENDPOINTS.SELLERS.UPDATE(id), payload);
    
    // Handle API response structure
    const apiData = (response as any)?.data || response;
    
    return {
      ...apiData,
      _id: apiData._id || apiData.id,
      id: apiData.id || apiData._id,
    };
  } catch (error) {
    throw error;
  }
};

/**
 * Delete seller
 */
export const deleteSeller = async (id: string): Promise<void> => {
  try {
    await secureApi.post<any>(SHOP_ENDPOINTS.SELLERS.DELETE(id));
  } catch (error: any) {
    throw error;
  }
};
